<template>
    <div class='metrics'>
        <div class='card'>
            <p class='amount'>{{ data.value }}</p>
            <p class='category'>{{ data.name }}</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "Metric",
    data: function(){
        return {

        }
    },
    props: {
        data: {
            type: Object,
            required: true,
            default: 'Need to pass an Object to Metrics component'
        }
    }
}
</script>

<style scoped lang='scss'>

    .metrics {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 16px;
        margin: 0 0 16px;

        .card {
            flex: 1;
            background-color: white;
            border-radius: 4px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
            padding: 16px 24px;
            min-width: 200px;

            p {
                color: rgb(116, 120, 141);
                font-size: 14px;
                margin-bottom: 0; // overrides v-application p rule
            }

            .amount {
                color: rgb(74, 80, 88);
                font-size: 22px;
                font-weight: 500;
            }

            .category {
                height: 40px;
                line-height: 16px;
            }

            .percent {

                .v-icon {
                    color: $secondary; // green
                    font-size: 16px;
                    margin-top: -4px;
                    margin-left: -2px;
                }

                span:first-of-type {
                    color: $secondary; // green
                }
            }
        }
    }
</style>
